import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Confirm from "../Confirm";
import { useLocation, useNavigate, Link } from "react-router-dom";
import trasportApi from "../../api/trasportApi";
import Main from "../layout/Main";
import Helmet from "react-helmet";
import { BsChevronRight } from "react-icons/bs";
import PubSub from "pubsub-js";


const ContactView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [supplier, setsupplierData] = useState(location.state ? location.state : {});
  const [modalShow, setModalShow] = useState(false);


  const isdelete = async () => {
    let result = await trasportApi.deleteSupplier(location.state.id);
    if (result.success){
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record deleted successfully' });
        navigate(`/suppliers`);
    } 
  };

  const editSupplier = () => {
    navigate(`/suppliers/${supplier.id}/e`, { state: supplier });
  };

  return (
    <Main>
      <>
        <Helmet>
          <title>
             {`${supplier.firstname} ${supplier.lastname}`} 
          </title>
        </Helmet>
      </>
      <div>
        {supplier && (
          <Container>
            {modalShow && (
              <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              isdelete={isdelete}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="supplier"
            />
            )}

        
            <Col lg={2} className="mx-2">
              <Link to="/home" style={{ "text-decoration": "none" }}>
                Home
              </Link>{" "}
              {/* <i className="fa-solid fa-chevron-right"></i> */}
              <BsChevronRight/>
              <Link to="/suppliers" style={{ "text-decoration": "none" }}>
                Suppliers
              </Link>
            </Col>
            <Row className="view-form">
              <Col></Col>
              <Col lg={8}>
                <Row className="view-form-header align-items-center">
                  <Col lg={4}>
                    {/* <div>supplier Id: {supplier.contactno}</div> */}
                    <h5>
                      {supplier.name}{" "}
                    </h5>
                  </Col>
                  <Col lg={8} className="d-flex justify-content-end">
                      <Button
                        className="btn-sm mx-2"
                        onClick={() => editSupplier(true)}
                        >
                      <i className="fa-regular fa-pen-to-square"></i>
                    </Button>
                    <Button
                      className="btn-sm"
                      variant="danger"
                      onClick={() => setModalShow(true)}
                    >
                      Delete
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <label>Phone</label>
                    <span>{supplier.phone}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Email</label>
                    <span>{supplier.email}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Address</label>
                    <span>{supplier.address}</span>
                  </Col>
                  
                  <Col lg={6}>
                    <label>City</label>
                    <span>{supplier.city}</span>
                  </Col>
                 
                  <Col lg={12}>
                    <Col className="section-header my-3">
                      <span style={{ color: "blue", paddingLeft: "10px" }}>
                        Contact Person's Information
                      </span>
                    </Col>
                  </Col>
                  <Col lg={6}>
                    <label>Person Name</label>
                    <span>{supplier.person_name}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Person Email</label>
                    <span>{supplier.person_email}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Person Phone</label>
                    <span>{supplier.person_phone}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Person Department</label>
                    <span>{supplier.person_department}</span>
                  </Col>
              
                  <Col lg={6}>
                    <label>Person Designation</label> 
                    <span>{supplier.person_designation}</span>
                  </Col>
                  <Col lg={12}>
                    <Col className="section-header my-3">
                      <span style={{ color: "blue", paddingLeft: "10px" }}>
                        User Information
                      </span>
                    </Col>
                  </Col>
                  <Col lg={6}>
                    <label>Created By</label> 
                    <span>{supplier.createdbyname}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Lastmodified By</label> 
                    <span>{supplier.lastmodifiedbyname}</span>
                  </Col>
                </Row>
              </Col>
              <Col></Col>
             
            </Row>
          </Container>
        )}
      </div>
    </Main>
  );
};
export default ContactView;
